import { render, staticRenderFns } from "./AsignacionCompFormHeader.vue?vue&type=template&id=aceb3f58&scoped=true&"
import script from "./AsignacionCompFormHeader.vue?vue&type=script&lang=js&"
export * from "./AsignacionCompFormHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceb3f58",
  null
  
)

/* custom blocks */
import block0 from "./AsignacionCompFormHeader.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
